import "./RandomWord.css";

function RandomWord({ word }) {
  return <h2 className="Random-word">{word}</h2>;
}

export default RandomWord;
